import React from "react";
import { AidDemoVideoSection } from "components/platform/ai-decisioning";
import { sectionSpacingY } from "components/section";
import { useWarehouseCdp } from "contexts/warehouse-cdp-context";
import { type TextTitleProps } from "ui/text";

export function WarehouseAidVideo({ textMaxW = "720px" }: { textMaxW?: TextTitleProps["maxW"] }) {
  const { warehouse } = useWarehouseCdp();

  return (
    <AidDemoVideoSection
      my={0}
      pt={sectionSpacingY}
      title={`Power 1:1 personalization with AI Decisioning on ${warehouse.name}`}
      description="Use AI agents to deliver unique and optimized experiences for every customer based on the rich data and ML insights in your data lakehouse."
      textMaxW={textMaxW}
    />
  );
}
